<div style="background: #fff">

    <ion-list class="popover-list">
        <ion-item (click)="gotoNotification(n)" lines="solid" *ngFor="let n of notifications" [className]="n.isSeen ? 'isSeen':'notSeen'">
            <ion-label class="ion-text-wrap">
                <small>   {{n.msg}}</small>

                <p class="text-right "><small> {{n.createdAt | date:'YYYY-MM-dd hh:mm'}}</small></p>

            </ion-label>

        </ion-item>
    </ion-list>

</div>
